import React, { useState } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import {
	setGlobalIngredientComponentTranslation,
	updateGlobalIngredientComponentTranslation,
	resetState,
} from './store/globalIngredientComponentTranslations.actions';

// components
import { ReactDataWrapper } from 'reactDataWrapper';
import GlobalIngredientComponentTranslationsModalBatch from './components/batch/globalIngredientComponentTranslationsModalBatch';
import { Tooltip, Icon, Button, Input } from 'dumb';

// services
import {
	fetchAllGlobalIngredientComponentTranslations,
	deleteGlobalIngredientComponentTranslations,
	editGlobalIngredientComponentTranslations,
} from './globalIngredientComponentTranslations.service';

// utils
import { getEditedValues } from 'services/utils';

// phrases
import phrases from './globalIngredientComponentTranslations.phrases';

const columns = [
	{
		Header: 'Name',
		id: 'name',
		accessor: 'name',
		filterPath: ':name',
	},
	{
		Header: 'Language',
		id: 'language',
		accessor: 'language.name',
		filterPath: ':language.name',
	},
];

const IngredientComponentTranslation = ({ id }) => {
	const dispatch = useDispatch();
	const { tableKey, globalIngredientComponentTranslation, originalGlobalIngredientComponentTranslation } = useSelector(
		(store) => store.globalIngredientComponentTranslations
	);

	const [showBatchModal, setShowBatchModal] = useState(false);

	// crud
	const fetchData = (state) => fetchAllGlobalIngredientComponentTranslations(id, state);
	const editEntry = () => {
		const valuesToEdit = getEditedValues({
			newData: globalIngredientComponentTranslation,
			oldData: originalGlobalIngredientComponentTranslation,
		});

		const payload = {
			id: globalIngredientComponentTranslation.id,
			name: valuesToEdit.name,
		};

		return editGlobalIngredientComponentTranslations(payload);
	};
	const deleteEntry = (id) => deleteGlobalIngredientComponentTranslations(id);

	// crud prep
	const setInitialEditValues = (data) => {
		const body = {
			id: data.id,
			name: data.name,
			language: data.language.name,
		};

		dispatch(setGlobalIngredientComponentTranslation(body));
	};
	const getEditableCells = () => [
		{
			header: 'Name',
			value: (
				<Input
					id="name"
					placeholder={phrases.NAME}
					value={globalIngredientComponentTranslation.name}
					onChange={(event) => dispatch(updateGlobalIngredientComponentTranslation({ name: event.target.value }))}
				/>
			),
		},
		{
			header: 'Language',
			value: <span>{globalIngredientComponentTranslation.language}</span>,
		},
	];

	const toggleBatchModal = () => setShowBatchModal(!showBatchModal);
	const onRdwModalClose = () => dispatch(resetState());

	return (
		<>
			<ReactDataWrapper
				key={tableKey}
				accessAreasAllowedToEdit={['Sales Configuration']}
				title={phrases.TITLE}
				columns={columns}
				fetchData={fetchData}
				filterable
				defaultPageSize={10}
				reduxKey={`${id}-product/global_ingredient_components`}
				manual
				editableCells={getEditableCells()}
				setInitialEditValues={setInitialEditValues}
				onModalClose={onRdwModalClose}
				deleteEntry={deleteEntry}
				editEntry={editEntry}
				actionRender={
					<Tooltip
						text={phrases.BATCH_ADD}
						renderData={(ref, onMouseEnter, onMouseLeave) => (
							<Button
								label="Add"
								shadow
								type="inverted"
								onClick={toggleBatchModal}
								refProp={ref}
								onMouseEnter={onMouseEnter}
								onMouseLeave={onMouseLeave}
							>
								<Icon name="add" />
							</Button>
						)}
					/>
				}
			/>

			{showBatchModal && <GlobalIngredientComponentTranslationsModalBatch onClose={toggleBatchModal} allergenId={id} />}
		</>
	);
};

IngredientComponentTranslation.propTypes = {
	id: PropTypes.number,
};

export default IngredientComponentTranslation;
